export const getTrafficStatus = (state) => state.publicData.trafficStatus;
export const getLoadingTrafficStatus = (status) => status.publicData.loadingTrafficStatus;